import { List, Box, Flex } from '@mantine/core';
import { ColoredCircle } from 'components/ColoredCircle/ColoredCircle';
import { Orientation } from 'models/charts';
import { IconType } from 'react-icons';

interface LegendItem {
  title: string;
  color: string;
  innerColor?: string;
  icon?: IconType;
  onClick?: (label: string) => void;
  label?: string;
}

interface LegendProps {
  layout?: Orientation;
  items?: LegendItem[];
}

export const Legend = (props: LegendProps) => {
  const { layout = Orientation.Horizontal, items } = props;

  const renderIcon = ({ icon: Icon, color, innerColor }: LegendItem) => {
    if (Icon) return <Icon size={16} color={color} />;

    return <ColoredCircle color={color} innerColor={innerColor} />;
  };

  const handleOnClick = ({ label, onClick }: LegendItem) => {
    if (label && onClick) {
      onClick(label);
    }
  };

  if (layout === Orientation.Horizontal) {
    return (
      <Flex py={10}>
        {items?.map((item) => (
          <Flex align={'center'} pr={10} key={item.title} onClick={() => handleOnClick(item)}>
            {renderIcon(item)}
            <Box ml={5} data-testid={`legend-label-${item.label}`}>
              {item.title}
            </Box>
          </Flex>
        ))}
      </Flex>
    );
  }

  return (
    <List size={'md'}>
      {items?.map((item) => {
        return (
          <List.Item
            styles={{ itemWrapper: { alignItems: 'center', cursor: item.onClick && 'pointer' } }}
            key={item.title}
            icon={renderIcon(item)}
            pb={10}
            onClick={() => handleOnClick(item)}
            data-testid={`legend-label-${item.label}`}
          >
            {item.title}
          </List.Item>
        );
      })}
    </List>
  );
};
